import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";
import PDFViewerImage23 from "../../../../assets/PDFViewerImages/PDFViewerImage23.jpg";
import PDFViewerImage24 from "../../../../assets/PDFViewerImages/PDFViewerImage24.jpg";
import PDFViewerImage25 from "../../../../assets/PDFViewerImages/PDFViewerImage25.jpg";

const Chapter15 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>

              {/* Chapter 15 */}
                <section id="section15" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">
                        {language.chapter15Title}
                    </h2>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter15Paragraph1}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter15Paragraph2}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter15Paragraph3}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage23} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter15Paragraph4}

                    </p>

                    <h3 className="drivers-handbook-subheading">
                        {language.chapter15Subheading1}
                    </h3>
                    <ul className="drivers-handbook-list">
                        <li>{language.chapter15List11}</li>
                        <li>{language.chapter15List12}</li>
                        <li>
                           {language.chapter15List13}

                        </li>
                    </ul>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter15Paragraph5}


                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage24} alt="Traffic Rules"/>
                    </div>


                    <h3 className="drivers-handbook-subheading">{language.chapter15Subheading2}</h3>
                    <ul className="drivers-handbook-list">
                        <li>{language.chapter15List21}</li>
                        <li>{language.chapter15List22}</li>
                        <li>{language.chapter15List23}</li>
                    </ul>

                    <div className="image-box">
                        <img src={PDFViewerImage25} alt="Traffic Rules"/>
                    </div>


                </section>
        </>
    )

}

export default Chapter15;
